import { useContext } from 'react';
import { AssignmentDetailsContext } from './components/Context';
import { ASSIGNMENT_DETAILS_CONTEXT_ERROR_MESSAGE } from './constants';
import { AssignmentDetailsContextState } from './types';

export const useAssignmentDetails = (): AssignmentDetailsContextState => {
  const context = useContext(AssignmentDetailsContext);

  if (context === undefined) {
    throw Error(ASSIGNMENT_DETAILS_CONTEXT_ERROR_MESSAGE);
  }

  return context;
};
